var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    [
      _vm.$slots.label || _vm.label
        ? _c(
            "label",
            { attrs: { for: _vm.field } },
            [
              _vm.$slots.label
                ? _vm._t("label")
                : _vm.label
                ? _c("span", [_vm._v(" " + _vm._s(_vm.label) + " ")])
                : _vm._e(),
              _vm.required(
                _vm.$validator._base.fields.items.find(function(_i) {
                  return _i.name === _vm.field
                })
              )
                ? _c("span", { staticClass: "text-danger font-bold" }, [
                    _vm._v(" * ")
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        [
          _vm._t("default", null, {
            invalid: _vm.$validator._base.errors.has(this.field) ? false : null
          })
        ],
        2
      ),
      _vm.$validator._base.errors.has(this.field)
        ? _c("v-invalid-feedback", [
            _vm._v(
              " " + _vm._s(this.$validator._base.errors.first(this.field)) + " "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }